import { deepCopy } from '@/util/deep-copy'
const moment = require('../../../../util/MPMoment')

class ReservationPositionCalculator {
    constructor() {
        this.startTime = undefined
        this.influenceRange = []
        this.columns = []

        this._reservations = undefined
    }

    get calculatedData() {
        return this.columns
    }

    get reservations() {
        return this._reservations
    }

    set reservations(newValue) {
        if (newValue == undefined) {
            this._reservations = newValue
            return
        }
        this._reservations = deepCopy(newValue)
    }

    async run() {
        if (!this._reservations) { return }

        return new Promise( (resolve, reject) => {
            try {
                this.sortAndCalculatePositions()
                this.calculateWidthAndLeft()
            } catch(err) {
                console.log('calculator error : ', err)
                reject(err)
            }

            resolve(this._reservations)
        })
    }

    sortAndCalculatePositions() {
        this._reservations.sort((l, r) => {
            let diff = moment(l.startedAt).startOf('minute').diff(moment(r.startedAt).startOf('minute'))
            if (diff != 0) {
                return diff
            }
            return moment(r.endedAt).startOf('minute').diff(moment(l.endedAt).startOf('minute'))

        })

        for (let i = 0; i < this._reservations.length; i++) {
            let placed = false

            let reservation = this._reservations[i]

            reservation.startY = moment(reservation.startedAt).startOf('minute').diff(this.startTime, 'minutes')
            reservation.endY = reservation.startY + moment(reservation.endedAt).startOf('minute').diff(reservation.startedAt, 'minutes') - 1

            for (let j = 0; j < this.columns.length && !placed; j++) {
                if (!this.inRange(this.influenceRange[j], reservation)) {
                    this.placeReservation(reservation, j)
                    placed = true
                }
            }
            if (!placed) {
                this.placeReservation(reservation)
            }
        }
    }

    placeReservation(reservation, index = this.columns.length) {
        this.initColumnAndRangeIfNeeded(index)

        this.setInfluenceRange(reservation, index)

        reservation.x = index

        this.columns[index].push(reservation)
    }

    initColumnAndRangeIfNeeded(index) {
        if (!this.columns[index]) {
            this.columns[index] = []
            this.influenceRange[index] = new Set()
        }
    }

    setInfluenceRange(reservation, index) {
        for (let p = reservation.startY; p <= reservation.endY; p++) {
            this.influenceRange[index].add(p)
        }
    }

    calculateWidthAndLeft() {
        for (let i = 0; i < this.columns.length; i++) {
            for (let k = 0; k < this.columns[i].length; k++) {
                this.calculateReservationWidthAndPosition(this.columns[i][k], i)
            }
        }
        this._reservations = this.columns.flat()
    }

    calculateReservationWidthAndPosition(reservation, columnIndex) {
        const startIndex = columnIndex == 0 ? 1 : columnIndex + 1
        const nonOverlapCount = this.countNonOverlappingCoordinates(reservation, startIndex)

        if (columnIndex === 0) {
            if (nonOverlapCount == 0) {
                reservation.width = 100
            } else {
                reservation.width = nonOverlapCount / this.columns.length * 100
            }
        } else {
            const previousColumnWidth = this.getLeftDataWidth(columnIndex - 1, reservation)

            if (nonOverlapCount != 0) {
                reservation.width = previousColumnWidth * nonOverlapCount
                reservation.left = previousColumnWidth * columnIndex
            } else {
                reservation.width = 100 - (previousColumnWidth * columnIndex)
                reservation.left = 100 - reservation.width
            }
        }
    }



    countNonOverlappingCoordinates(reservation, startIndex) {
        let infX = 1
        for (let i = startIndex; i < this.influenceRange.length; i++) {
            if (!this.inRange(this.influenceRange[i], reservation)) {
                infX++
            } else {
                break
            }
        }
        return infX % this.influenceRange.length
    }

    inRange(range, reservation) {
        for (let y = reservation.startY; y <= reservation.endY; y++) {
            if (range?.has(y)) {
                return true
            }
        }
        return false
    }

    getLeftDataWidth(index, currentReservation) {
        for (let i = 0; i < this.columns[index].length; i++) {
            let existingReservation = this.columns[index][i]
            if (this.hasIntersection(currentReservation, existingReservation)) {
                return existingReservation.width
            }
        }
        return 0
    }

    hasIntersection(currentReservation, existingReservation) {
        const currentStart = moment(currentReservation.startedAt).startOf('minute')
        const currentEnd = moment(currentReservation.endedAt).startOf('minute')
        const existingStart = moment(existingReservation.startedAt).startOf('minute')
        const existingEnd = moment(existingReservation.endedAt).startOf('minute')

        const startsWithinExisting = currentStart.isSameOrAfter(existingStart) && currentStart.isBefore(existingEnd);
        const endsWithinExisting = currentEnd.isAfter(existingStart) && currentEnd.isSameOrBefore(existingEnd);
        const encompassesExisting = currentStart.isBefore(existingStart) && currentEnd.isAfter(existingEnd);

        return startsWithinExisting || endsWithinExisting || encompassesExisting
    }
}

export default ReservationPositionCalculator